import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IOrdersReceipt } from 'src/types/OrderHistory';
import { sdk } from 'src/utilities/sdk';
import { pushErrorFromAPI } from 'src/utilities/notifications';

export default function useOrder(): IOrdersReceipt {
  const [order, setOrder] = useState<IOrdersReceipt>(null);

  const { corpid, orderId } = useParams<{ corpid: string; orderId: string }>();

  useEffect(() => {
    const getOrder = async () => {
      try {
        const order = await sdk.http.get(`/corps/${corpid}/orders/${orderId}`);
        setOrder(order);
      } catch (error) {
        pushErrorFromAPI(error);
      }
    };

    getOrder();
  }, [corpid, orderId]);

  return order;
}
